export default __webpack_public_path__ + "static/media/language-icon.f4977044.svg";